export function hasChanges(update: Record<string, unknown>, project: Record<string, unknown>) {
  return Object.keys(update).some((key) => update[key] !== project[key]);
}
